import React from 'react';
import {
    Box,
    TextField,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    Grid,
} from "@mui/material";
//import { makeStyles } from '@mui/styles';

// const useStyles = makeStyles({
//     actionContainer: {
//         display: 'flex',
//         paddingTop: 20,
//     }
// });

const ProjectListTableHeader = (props) => {

    const [aircraft, setAircraft] = React.useState('');
    const changeAircraft = (craft) => {
        setAircraft(craft);
    }

    const [search, setSearch] = React.useState('');
    const changeSearch = (input) => {
        setSearch(input);
    }

    //const classes = useStyles();
    const {sortAircraft, sortBySearch} = props;

    return(

        <Grid container sx={{display: 'flex', paddingTop: '20px'}} style={{width: '100%'}} spacing={3}>
            <Grid size={{ md: 6, sm: 12, xs: 12 }}>
                <Box>
                    <FormControl style={{width: '100%'}}>
                        <TextField
                            id="standard-adornment-amount"
                            label={'Search'}
                            variant={'outlined'}
                            value={search}
                            onChange={(e) => {
                                changeAircraft('');
                                sortAircraft('');
                                sortBySearch(e.target.value);
                                changeSearch(e.target.value)
                            }}
                        />
                    </FormControl>
                </Box>
            </Grid>
            <Grid size={{ md: 6, sm: 12, xs: 12 }}>
                <Box>
                    <FormControl style={{width: '100%'}} variant="outlined">
                        <InputLabel id="demo-simple-select-outlined-label">Aircraft Type</InputLabel>
                        <Select
                            label={'Aircraft Type'}
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            value={aircraft}
                            onChange={(e) => {
                                changeSearch('');
                                sortBySearch('');
                                sortAircraft(e.target.value);
                                changeAircraft(e.target.value);
                            }}
                        >
                            <MenuItem value={''}>
                                <em>All</em>
                            </MenuItem>
                            {props.aircraft.map((craft, idx) =>
                                <MenuItem key={idx} value={craft}>{craft}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </Box>
            </Grid>
        </Grid>
    )
}

export default ProjectListTableHeader;